export default "__VITE_ASSET__CIcqQUH$__"